// Import model
import { UpdateContactTaskRequest } from '../models/UpdateContactTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateContactTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateContactTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateContactTaskRequest instance
   */
  static deserialize(json: string): UpdateContactTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateContactTaskRequest instance
   */
  static fromObject(obj: any): UpdateContactTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateContactTaskRequest');
    }


    const instance: UpdateContactTaskRequest = {
      content: obj['content'] as string | undefined,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string | undefined,
      dueDate: obj['dueDate'] as string | undefined,
      priority: obj['priority'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateContactTaskRequest instances
   */
  static deserializeArray(json: string): UpdateContactTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateContactTaskRequest instance to a JSON string
   */
  static serialize(instance: UpdateContactTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateContactTaskRequest instance to a plain object
   */
  static toObject(instance: UpdateContactTaskRequest): any {
    return {
      'content': instance.content,
      'description': instance.description,
      'name': instance.name,
      'dueDate': instance.dueDate,
      'priority': instance.priority,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of UpdateContactTaskRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateContactTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
